import ModalWrapper from "js/Component/ModalWrapper";
import { memo } from "react";
import moment from 'moment';

const AnnouncementModal = (props) => {
    const { visible, count, target, onClose, onCancel, onOkPress, isTemplate, startTime, formStatus, UpdatedformStatus } = props;

    if (!visible) return null;

    let message = ""
    if (isTemplate) {
        message = `This will send the form to `;
        if (target.id !== "every_one") {
            message = message + (count.toString() + " " + target.name.replace("Select", "Selected"));
        }
        else {
            message = message + " everyone"
        }
    }
    else {
        message = "The form will appear for "
        if (target.id !== "every_one") {
            message = message + (count.toString() + " " + target.name.replace("Select", "Selected"));
        }
        else {
            message = message + " everyone"
        }
        message = message + " at " + moment(startTime).format('hh:mm a') + " local time on " + moment(startTime).format('DD/MM/YYYY')
    }

    return (
        <ModalWrapper>
            {!isTemplate ?
                <>
                    <div class="modal-header">
                        <h1 class="modal-title">{formStatus === "published" && UpdatedformStatus === "published" ? "Save and send updates" : "Publish Form"}</h1>
                        <button className="close-button" style={{ alignSelf: "flex-end" }} onClick={onClose} > &times; </button>
                    </div>
                </>
                :
                <button className="close-button" style={{ alignSelf: "flex-end" }} onClick={onClose} > &times; </button>
            }
            <div className="modal-body" style={{ textAlign: "center" }}>
                <h4 className="p-0 m-0">{message}</h4>
                <h4 className="p-0 mb-4">{`Continue?`}</h4>
                <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                    <button className="btn bg-white border border-dark text-dark px-4 py-2" onClick={onCancel} > Cancel </button>
                    <button className="btn btn-dark text-white px-5 py-2" onClick={onOkPress} >  OK  </button>
                </div>
            </div>
        </ModalWrapper>
    );
};

export default memo(AnnouncementModal);
